import { QUERY_KEY } from '@constants/queries';

import { useQuery } from '@tanstack/react-query';
import { GET } from '@lib/axios';
import { ApiListResponse, PublicEpisode } from '@utils/typesPages/types';

export const fetchAllEpisodes = async () => {
  const { data: response } = await GET<ApiListResponse<PublicEpisode[]>>(
    '/api/episodes/'
  );

  return response;
};

export const useFetchAllEpisodes = () => {
  return useQuery({
    queryKey: [QUERY_KEY.FETCH_EPISODES_ALL_PUBLIC],
    queryFn: () => fetchAllEpisodes(),
    refetchInterval: 300000,
    gcTime: 300000,
  });
};
